import { Theme } from "@mui/material/styles";

export const DrawerPaperStyle = (theme: Theme) => ({
    width: 280,
    border: "none",
    boxShadow: theme.shadows[4],
    backgroundColor: theme.palette.background.paper,
    transition: `background-color 250ms cubic-bezier(0.2, 0, 0, 1.0)`,
    bottom: 0,
    height: "100%",
    overflowX: "hidden",
});